import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const scraperSourcesApi = {
  /**
   * @param {{ skip?: number; limit?: number }} [params]
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').ScraperSource[]>>}
   */
  list: (params = {}, config = {}) =>
    mod.get('/scraper-sources/', { ...config, params: { limit: 200, ...params } }),

  /**
   * @param {{ url: string; topic_ids?: number[]; status?: 'active'|'paused' }} body
   */
  create: (body, config) => mod.post('/scraper-sources/', body, config),

  /**
   * @param {number} id
   * @param {{ topic_ids?: number[]; status?: 'active'|'paused' }} body
   */
  update: (id, body, config) => mod.put(`/scraper-sources/${id}`, body, config),

  /**
   * List the moderator's own topics, for the topic picker.
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').SubscriptionTopic[]>>}
   */
  listTopics: (config = {}) => mod.get('/scraper-sources/topics', config),

  /** @param {number} id */
  remove: (id, config) => mod.delete(`/scraper-sources/${id}`, config),

  /** Toggle active ↔ paused. @param {number} id */
  toggle: (id, config) =>
    mod.patch(`/scraper-sources/${id}/toggle`, null, config),

  /** @param {number} id */
  listExecutions: (id, params = {}, config = {}) =>
    mod.get(`/scraper-sources/${id}/executions`, {
      ...config,
      params: { limit: 20, ...params },
    }),
};
